

export const getContent = (state, id) =>  (state.content[id]) ? state.content[id].content : "";
export const getLoading = (state, id) => (state.content[id]) ? state.content[id].loading : false;
export const getError = (state, id) => (state.content[id]) ? state.content[id].error : "";